import React, { useState, useReducer, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Paper, Typography } from "@material-ui/core";
import { useFlexLayout } from "react-table";


export default function PaymentCard(props) {
  const { icon, text, subtext, color, selected, paymentId, handleChange } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      cursor: "pointer",
      marginTop: 8,
      height: 50,
      width: 350,
      paddingLeft: 8,
      display: "flex",
      alignItems: "center",
      transition: "background-color 0.4s",
      boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
      "&:hover": {
        backgroundColor: '#eeeeee',
        boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.3)",
        transition: "background-color 0.4s",
      }
    }
  }));
  const classes = useStyles();

  return (
    <Paper className={classes.root} onClick={() => { handleChange && handleChange(paymentId) }} style={{ backgroundColor: (selected) ? "#BCDBF6" : color }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {icon}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "left", justifyItems: "center", paddingLeft: 16 }}>
          <Typography variant="body1">{text}</Typography>
          {subtext && <Typography variant="body2" color="secondary">{subtext}</Typography>}
        </div>
      </div>
    </Paper>
  );
}
